<div class="d-flex flex-row mt-2 pb-3 w-100">
    <button mat-icon-button class="me-2 text-danger"><mat-icon>person</mat-icon></button>
    <div class="me-auto">
        <b (click)="dialogService.viewCertificates(addWizObj.applicantId)"
            class="text-clickable m-2">{{personalInfo?.firstName}} {{personalInfo?.lastName}}</b>
        <br />
        <span (click)="dialogService.viewCertificates(addWizObj.applicantId)"
            class="text-clickable m-2">{{addWizObj.applicantId}} ({{addWizObj.approachDisplay}})</span>
    </div>
</div>
<div class="mt-2">
    <span class="my-auto rounded m-2 p-2 badge-bg-primary align-top">{{addWizObj.status?.Display || 'Started'}}</span>
</div>
<div>
    <app-app-wizard-percent *ngIf="addWizObj.hasExpiry()"
        [percentageComplete] = "addWizObj.percentageComplete"
        [deadlineRemain] = "addWizObj.deadlineRemain"
        [deadlineTotal] = "addWizObj.deadlineTotal"
    ></app-app-wizard-percent>
</div>
<div class="mt-2">
    <div class="pt-2"><span class="body-title">{{addWizObj.approachDisplay}} Application:
        </span><span>{{addWizObj.appId}}</span></div>
    <div class="pt-2"><span class="body-title">Originator: </span><span>{{addWizObj.originatorFirstName + " " +
            addWizObj.originatorLastName}} | {{addWizObj.appId}}</span></div>
    <div class="pt-2">
        Start: {{addWizObj.startedDate | date:'MM/dd/yyyy'}}
        <ng-container *ngIf="addWizObj.hasDeadline()"> | Deadline: {{addWizObj.deadlineDate | date:'MM/dd/yyyy'}}</ng-container>
    </div>
    <ng-container *ngIf="addWizObj.approach === 'PrincipalAct' && addWizObj.appExtensionsList?.[0]?.properties as pa">
        <div class="pt-2 d-flex flex-wrap align-items-center gap-2">
            <span class="rounded px-2 py-1"
                [style.background-color]="pa.hardToStaff ? '#e6f4ea' : '#fbf0db'"
                [style.color]="pa.hardToStaff ? '#1e7e34' : '#8a6d3b'">
                Hard to Staff = {{ pa.hardToStaff ? 'Yes' : 'No' }}
            </span>
            <span class="rounded px-2 py-1"
                [style.background-color]="pa.retireEndOfSchoolYear === 'Yes' ? '#e6f4ea' : '#fbf0db'"
                [style.color]="pa.retireEndOfSchoolYear === 'Yes' ? '#1e7e34' : '#8a6d3b'">
                Retirement at End of School Year = {{ pa.retireEndOfSchoolYear === 'Yes' ? 'Yes' : 'No' }}
            </span>
        </div>
        <div class="pt-2">
            Base Stipend: {{pa.baseStipendAmount | currency}}
            | Hard-to-Staff Supplement: {{pa.supplementAmount | currency}}
        </div>
    </ng-container>
</div>

<div class="mt-2">
    <button class="btn btn-link m-2" (click)="viewDocument()" *ngIf="getAppPDFDocId()">Application</button>
</div>
<div class="mt-2">
    <button mat-raised-button class="header-button mt-2" (click)="deleteApp()" *ngIf="addWizObj.status?.Value=='started'">
        <span class="material-symbols-outlined pt-2">delete</span>
    </button>
</div>